import FaceIcon from '@mui/icons-material/Face';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, FormControl, FormControlLabel, Grid, Paper, Switch, TextField, Typography, useTheme } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../../app/store';
import TextFieldData from '../../../../../components/formControls/TextFieldData';
import { formatarDataDDMMYYYY, parseDateDDMMYYYY } from '../../../../../utils/formatDate';
import {
  atualizarPublicacaoOficialApply,
  atualizarPublicacaoOficialDataFinal,
  atualizarPublicacaoOficialDataInicial,
  atualizarPublicacaoOficialSearch,
  atualizarPublicacaoOficialExercicio,
  atualizarPublicacaoOficialTipo
} from './publicacaoOficialPublicListFiltroSlice';
import TxtTipoPublicacaoOficialSite from '../../../../autoComplete/TxtTipoPublicacaoOficialSite';
import { IStipoPublicacaoOficial, TipoPublicacaoOficial, TipoPublicacaoOficialList } from '../../../../../typesSite/tipoPublicacaoOficial/TipoPublicacaoOficial';

interface PublicacaoOficialPublicListFiltroFormProps {
  handleBuscar: () => void;
  paramTipo?: string | null;
disabled?: boolean;
  //tipoPublicacaoOficialSelecionadoParam?: TipoPublicacaoOficial;
}

export default function PublicacaoOficialPublicListFiltroForm({ handleBuscar, paramTipo, disabled }: PublicacaoOficialPublicListFiltroFormProps) {
  const dispatch = useDispatch();
  const publicacaoOficialListFiltro = useSelector((state: RootState) => state.publicacaoOficialPublicListFiltro);

  const [expanded, setExpanded] = useState(false);
  const theme = useTheme();

  const handleToggleAccordion = () => {
    setExpanded(prev => !prev);
  };

  const handleDataInicial = (data: Date | null) => {
    dispatch(atualizarPublicacaoOficialDataInicial(formatarDataDDMMYYYY(data)));
  };
  const handleDataFinal = (data: Date | null) => {
    dispatch(atualizarPublicacaoOficialDataFinal(formatarDataDDMMYYYY(data)));
  };

  const handleExercicio = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const cursorPosition = e.target.selectionStart;

    // Só números
    const somenteNumeros = value.replace(/\D/g, '').slice(0, 4);

    dispatch(atualizarPublicacaoOficialExercicio(somenteNumeros));

    e.target.value = somenteNumeros;

    // Mantém o cursor no local correto
    setTimeout(() => {
      e.target.setSelectionRange(cursorPosition, cursorPosition);
    }, 0);
  };

  const [tipoPublicacaoOficialSelecionado, setTipoPublicacaoOficialSelecionado] = useState<TipoPublicacaoOficial>(IStipoPublicacaoOficial);
  const handletxtTipoPublicacaoOficialChange = (tipoPublicacaoOficial: TipoPublicacaoOficial) => {
    setTipoPublicacaoOficialSelecionado(tipoPublicacaoOficial as TipoPublicacaoOficial);
    dispatch(atualizarPublicacaoOficialTipo(tipoPublicacaoOficial as TipoPublicacaoOficialList));
  };

  const handleApplyFilter = (event: React.FormEvent) => {
    event.preventDefault();

    let dataInicial = parseDateDDMMYYYY(publicacaoOficialListFiltro.dataInicial);
    let dataFinal = parseDateDDMMYYYY(publicacaoOficialListFiltro.dataFinal);

    if (!dataInicial || dataInicial?.toDateString().toUpperCase() == 'INVALID DATE') {
      enqueueSnackbar('Data Inicial Inválida!', { variant: 'error' });
      return;
    }
    if (!dataFinal || dataFinal?.toDateString().toUpperCase() == 'INVALID DATE') {
      enqueueSnackbar('Data Final Inválida!', { variant: 'error' });
      return;
    }
    if (dataInicial > dataFinal) {
      enqueueSnackbar('Data Inicial maior que a Data Final!', { variant: 'error' });
      return;
    }
    dispatch(atualizarPublicacaoOficialApply());
  };
/*
  useEffect(() => {
    if (tipoPublicacaoOficialSelecionadoParam) {
      setTipoPublicacaoOficialSelecionado(tipoPublicacaoOficialSelecionadoParam);
    }
  }, [tipoPublicacaoOficialSelecionadoParam]);

*/


  return (
    <Paper>
      <Accordion expanded={expanded} onChange={handleToggleAccordion}>
        <AccordionSummary expandIcon={<FilterAltIcon />} aria-controls="panel1-content" id="panel1-header">
          <Typography color="secondary" variant="body1"  sx={{
                color: theme.custom.noticia.textTitle.color,
                fontFamily: theme.custom.noticia.textTitle.font,
                fontWeight: theme.custom.noticia.textTitle.fontWeight,
                fontSize: { xs: '15px', sm: '24px', md: '28px' }, // responsivo
                lineHeight: { xs: '15px', sm: '32px', md: '36px' }
              }}
            >
              Publicações Oficiais  {paramTipo ?   ' - ' + paramTipo : ''}
            <Typography
              sx={{
                color: theme.custom.noticia.textTitle.color,
                fontFamily: theme.custom.noticia.textTitle.font,
                fontWeight: theme.custom.noticia.textTitle.fontWeight,
                fontSize: { xs: '20px', sm: '24px', md: '28px' }, // responsivo
                lineHeight: { xs: '28px', sm: '32px', md: '36px' }
              }}
            >
              
            </Typography>
          </Typography>
        </AccordionSummary>

        <AccordionDetails>
          <Box p={2}>
            <Grid container spacing={3}>
              <Grid item xs={12} container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextFieldData label="Data Inicial" value={parseDateDDMMYYYY(publicacaoOficialListFiltro.dataInicial)} onChange={handleDataInicial} disabled={false} readOnly={false} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextFieldData label="Data Final" value={parseDateDDMMYYYY(publicacaoOficialListFiltro.dataFinal)} onChange={handleDataFinal} disabled={false} readOnly={false} />
                </Grid>

                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <TextField
                      required
                      label="Exercício:"
                      name="exercicio"
                      onChange={handleExercicio}
                      size="small"
                      inputProps={{
                        maxLength: 4,
                        inputMode: 'numeric',
                        pattern: '[0-9]*'
                      }}
                      value={publicacaoOficialListFiltro.exercicio}
                    />
                  </FormControl>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Box display="flex" justifyContent="space-between" gap={2}>
                  <FormControl fullWidth>
                    <TxtTipoPublicacaoOficialSite
                      isdisabled={disabled ? disabled : false}
                      value={publicacaoOficialListFiltro.tipo}
                      handleSearchChange={it => {
                        handletxtTipoPublicacaoOficialChange(it);
                      }}
                    />
                  </FormControl>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    label="Descreva um breve texto para pesquisar:"
                    name="search"
                    onChange={e => dispatch(atualizarPublicacaoOficialSearch(e.target.value))}
                    value={publicacaoOficialListFiltro.search}
                    size="small"
                    inputProps={{ maxLength: 50 }}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={e => {
                      handleApplyFilter(e); // valida
                      handleBuscar(); // dispara a requisição no PAI
                    }}
                    sx={{ marginBottom: 2 }}
                  >
                    Aplicar Filtro
                  </Button>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
        </AccordionDetails>
      </Accordion>
    </Paper>
  );
}

{
  /*
  const [search, setSearch] = useState<string>('');    

  const debounceTimeout = useRef<NodeJS.Timeout | null>(null);
    useEffect(() => {
      // Limpar o timeout anterior
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
  
      // Configurar o timeout para o debounce
      debounceTimeout.current = setTimeout(() => {        
        dispatch(atualizarPublicacaoOficialSearch(search))
      }, 700); // Tempo de debounce (700ms)
  
      // Limpar o timeout quando o componente for desmontado ou o efeito for reiniciado
      return () => {
        if (debounceTimeout.current) {
          clearTimeout(debounceTimeout.current);
        }
      };
    }, [search]); // Dependência do useEffect: quando o 'search' mudar
*/
}
